import { useState, useEffect } from "react";
import * as service from "../services/profileService";
import { validateRequiredFields } from "../../../../utils/helpers/validation/validateRequiredFields";

export const useProfile = () => {
  const [error, setError] = useState("");

  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    nationality: "",
    gender: "none",
    mobile: "",
    suburb: "",
    state: "",
    country: "",
    postcode: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const loadProfile = async () => {
    try {
      const res = await service.fetchProfile();
      setProfile(res.data);
    } catch (err) {
      console.error("Failed to fetch profile details:", err);
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const handleUpdatePersonalDetails = async () => {
    const isRequired = validateRequiredFields(profile, [
      "firstName",
      "lastName",
      "dob",
      "country",
    ]);

    if (!isRequired.isValid) {
      return setError({
        type: "error",
        message: "Fields marked with (*) are required.",
      });
    }

    setLoading(true);
    try {
      const res = await service.updateProfile(profile);
      if (res.success)
        setSuccessMessage("Personal details updated successfully.");
    } catch (err) {
      console.error(err);
    } finally {
      setError("");
      setTimeout(() => setLoading(false), 500);
    }
  };

  const handlePasswordUpdate = async (password) => {
    setLoading(true);
    try {
      const res = await service.updatePassword(password);
      if (res.success) setSuccessMessage("Password has been changed.");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    const confirmDelete = window.confirm(
      "Are you sure? This action is permanent.",
    );
    if (!confirmDelete) return;

    try {
      const res = await service.deleteAccount();
      if (res.data?.success || res.success) {
        window.location.href = "/";
      }
    } catch (err) {
      console.error("Frontend delete error:", err);
      alert("Could not delete account. Please try again.");
    }
  };

  return {
    profile,
    loading,
    successMessage,
    error,
    setProfile,
    setSuccessMessage,
    handleUpdatePersonalDetails,
    handlePasswordUpdate,
    handleDeleteAccount,
    loadProfile,
  };
};
